import {
  QueriedData,
  showErrorNotification,
  showSuccessNotification,
} from '../assets/useAssets';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  Service,
  ServiceWriteModel,
  createService,
  deleteService,
  getAllServices,
  updateService,
} from 'src/api/services';

export interface UseServicesResult {
  servicesQuery: QueriedData<Service[]>;
  createService: (service: ServiceWriteModel) => void;
  updateService: (data: { id: string; service: ServiceWriteModel }) => void;
  archiveService: (serviceID: string) => void;
}

function useCreateService() {
  const queryClient = useQueryClient();
  const { mutate: create } = useMutation(
    (service: ServiceWriteModel) => createService(service),
    {
      onSuccess: () => {
        showSuccessNotification('Serviço criado com sucesso');
        queryClient.invalidateQueries(['services']);
      },
      onError: () => {
        showErrorNotification('Ocorreu um erro inesperado');
      },
    },
  );
  return create;
}

export function useServices(): UseServicesResult {
  const query = useQuery({
    queryFn: async () => getAllServices(),
    queryKey: ['services'],
  });

  const create = useCreateService();
  const queryClient = useQueryClient();
  const { mutate: archive } = useMutation(
    (serviceID: string) => deleteService(serviceID),
    {
      onSuccess: () => {
        showSuccessNotification('Serviço arquivado com sucesso');
        queryClient.invalidateQueries(['services']);
      },
      onError: () => showErrorNotification('Ocorreu um erro inseperado'),
    },
  );
  const updateService = useUpdateService();
  return {
    servicesQuery: query,
    createService: create,
    archiveService: archive,
    updateService,
  };
}

export function useUpdateService() {
  const queryClient = useQueryClient();

  const { mutate: update } = useMutation(
    ({ id, service }: { id: string; service: ServiceWriteModel }) =>
      updateService(id, service),
    {
      onSuccess: (_, { id }) => {
        showSuccessNotification('Serviço criado com sucesso');
        queryClient.invalidateQueries(['services', id]);
        queryClient.invalidateQueries(['services']);
      },
      onError: () => {
        showErrorNotification('Ocorreu um erro inesperado');
      },
    },
  );
  return update;
}
